import _ from 'lodash';
import { client, clientWithoutErrorHandling } from '../http';
import store from '../store';
import router from '../router';

const API_REQUEST_PREFIX = '/api';
const INVITE_AUTH_PATH_PREFIX = `${API_REQUEST_PREFIX}/invite-auth`;

function init() {
  function addTokenToRequests(config) {
    if (_.startsWith(config.url, INVITE_AUTH_PATH_PREFIX)) {
      config.headers = _.extend(config.headers, { 'RISEUP-ACCESS-TOKEN': store.state.inviteSession.accessToken }); // eslint-disable-line
    }

    return config;
  }

  function handleError(error) {
    if (!error.response) {
      // Network error
      store.dispatch('genericError/setErrorType', store.state.genericError.ERROR_TYPES.NETWORK_ERROR);
    } else {
      const { status } = error.response;
      if (status === 502) {
        store.dispatch('genericError/setErrorType', store.state.genericError.ERROR_TYPES.SERVER_IS_DOWN);
      } else if (status === 403) {
        if (isMemberInvite()) {
          store.dispatch('genericError/setErrorType', store.state.genericError.ERROR_TYPES.INVITE_MEMBER_ERROR);
        } else {
          store.dispatch('loader/clearLoader');
          const query = { redirectTo: _.trimStart(window.location.pathname, '/'), ...router.currentRoute.query };
          const qs = new URLSearchParams(_.toPairs(query)).toString();
          /*
           * We reload the page and not use Vue Router to redirect to the login page
           * to make sure that all other HTTP requests are cancelled and won't
           * cause additional redirects after we navigate
           */
          window.location.assign(`/login?${qs}`);
        }
      } else if (status === 500) {
        store.dispatch('genericError/setErrorType', store.state.genericError.ERROR_TYPES.SERVER_ERROR);
      }
    }
    return Promise.reject(error);
  }

  function changeDemUrlIfNeeded(config) {
    if (router.currentRoute.name === 'Demo'
      && (config.url.startsWith('/api/budget')
      || config.url.startsWith('/api/application-state')
      || config.url.startsWith('/api/onboarding-state')
      || config.url.startsWith('/api/investigator/questions/merge/papas')
      || config.url.startsWith('/api/investigator/questions/merge/sons')
      || config.url.startsWith('/api/investigator/questions/budget-category'))) {
      config.url = config.url.replace('/api', '/api/demo'); // eslint-disable-line
      config.headers = _.extend(config.headers, { // eslint-disable-line
        demoPassword: router.currentRoute.query.demoPassword,
      });
    }
    return config;
  }

  client.interceptors.request.use(addTokenToRequests);
  client.interceptors.request.use(changeDemUrlIfNeeded);
  clientWithoutErrorHandling.interceptors.request.use(addTokenToRequests);

  client.interceptors.response.use(
    response => response,
    handleError,
  );

  function isMemberInvite() {
    return router.currentRoute.name === 'MemberInvite';
  }
}

export default {
  init,
};
